import client from '../httpClient';

const getLineReceptionListApi = async (params) => {
  const res = await client.get('/users/lineReceptions/', { params });
  return res;
};

export default getLineReceptionListApi;
